import {cn} from "@/lib/utils"

function Skeleton({
                      className,
                      ...props
                  }: React.HTMLAttributes<HTMLDivElement>) {
    return (
        <div
            className={cn(
                // "animate-pulse",
// NOTE:    https://tailwindcss.com/docs/animation#using-a-custom-value
                "animate-[pulse_1s_ease-in-out_infinite]",
                "rounded-md bg-primary/10", className)}
            {...props}
        />
    )
}

export {Skeleton}
